import { IStateProvider } from 'angular-ui-router';

import { SdcStateBuilder } from './sdc-state-builder.service';

RegentsPrepRouteConfig.$inject = ['$stateProvider'];

const SDC_KEY = 'regents-prep';

export function RegentsPrepRouteConfig($stateProvider: IStateProvider) {
  const regentsPrepGridState = SdcStateBuilder.buildGridState(SDC_KEY);
  const regentsPrepWizardState = SdcStateBuilder.buildRegentsPrepWizardState(SDC_KEY);
  const regentsPrepProfileState = SdcStateBuilder.buildProfileState(SDC_KEY);

  $stateProvider

    .state(`main.school.new-sdc.${SDC_KEY}`, {
      abstract: true,
      url: `/${SDC_KEY}`,
      template: `
      <sdc-root
      current-user="$resolve.currentUser"
      current-state="$resolve.currentState">
      </sdc-root>
        `,
    })

    .state(`main.school.new-sdc.${SDC_KEY}.grid`, regentsPrepGridState)
    .state(`main.school.new-sdc.${SDC_KEY}.wizard`, regentsPrepWizardState)
    .state(`main.school.new-sdc.${SDC_KEY}.profile`, regentsPrepProfileState);
}
